// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3sOkZ","label":"Completed_label__1WqCb"};